import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IHocSinhAceActionTypes } from "../../action-types/hoc-sinh/IHocSinhAceActionTypes";
import { IHocSinhAceReducer } from "../../page-state-model/hoc-sinh/IHocSinhAceReducer";
const iniState: IHocSinhAceReducer = {
    status: ePageBaseStatus.is_not_initialization,
    hocSinhAces: []
}
export const hocSinhAceReducer = (state: IHocSinhAceReducer = iniState, action: IHocSinhAceActionTypes): IHocSinhAceReducer => {
    switch (action.type) {
        case "HOC_SINH_ACE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "HOC_SINH_ACE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhAces: action.payload
            }
        case "HOC_SINH_ACE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhAces: []
            }
        case "HOC_SINH_ACE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "HOC_SINH_ACE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "HOC_SINH_ACE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "HOC_SINH_ACE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "HOC_SINH_ACE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "HOC_SINH_ACE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "HOC_SINH_ACE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "HOC_SINH_ACE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}